import { render, staticRenderFns } from "./NameSystemQuizView.vue?vue&type=template&id=4aaf79a3&scoped=true&"
import script from "./NameSystemQuizView.vue?vue&type=script&lang=js&"
export * from "./NameSystemQuizView.vue?vue&type=script&lang=js&"
import style0 from "./NameSystemQuizView.vue?vue&type=style&index=0&id=4aaf79a3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4aaf79a3",
  null
  
)

export default component.exports